module.exports = __webpack_public_path__ + "47b35c34b975a45a8c097b36c640a18c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/subImg/spr-xkyd.jpg
// module id = 1168
// module chunks = 0